export default { sha: '44c3a7f507ea47092c274f760be063c10bee1fed', buildNumber: 'undefined' }
